import React from 'react';
import { FaUndo, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

const Returns = () => {
  return (
    <div className="py-16 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">Returns & <span className="text-orange-500">Exchange</span></h1>
          <div className="w-20 h-1 bg-orange-500 mx-auto"></div>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 mb-8">
          <FaUndo className="text-5xl text-orange-500 mx-auto mb-6" />
          <h2 className="text-2xl font-semibold text-center mb-4">30-Day Hassle-Free Returns</h2>
          <p className="text-gray-600 text-center mb-6">Not satisfied? Return within 30 days for a full refund or exchange.</p>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="border rounded-xl p-4">
              <FaCheckCircle className="text-green-500 text-2xl mb-2" />
              <h3 className="font-bold text-lg">Eligible</h3>
              <ul className="text-sm text-gray-600 list-disc list-inside mt-2">
                <li>Unused frames</li>
                <li>Original packaging</li>
                <li>Within 30 days</li>
              </ul>
            </div>
            <div className="border rounded-xl p-4">
              <FaTimesCircle className="text-red-500 text-2xl mb-2" />
              <h3 className="font-bold text-lg">Not Eligible</h3>
              <ul className="text-sm text-gray-600 list-disc list-inside mt-2">
                <li>Customized lenses</li>
                <li>Damaged products</li>
                <li>After 30 days</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="bg-orange-50 rounded-2xl p-6 text-center">
          <p className="text-gray-700">To initiate a return, please contact our support team at <span className="font-semibold text-orange-600">info@brframes.com</span> or call <span className="font-semibold text-orange-600">9709799555</span>.</p>
        </div>
      </div>
    </div>
  );
};

export default Returns;